import { useDebounce } from '@react-hook/debounce'
import { Button, Card, Input, Select } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface SearchState {
  id?: string
  publicId?: string
  customer?: string
  address?: string
}

type SearchableColumns = keyof SearchState

interface Props {
  onFilter: (state: SearchState) => void
}

const searchableColumns: SearchableColumns[] = [
  'address',
  'customer',
  'publicId',
  'id',
]

const SourcesFilter = ({ onFilter }: Props) => {
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState<SearchState>({})
  const [debouncedSearchQuery, setDebouncedSearchQuery] =
    useDebounce<SearchState>(searchQuery, 500)
  const [selectedFilterColumn, setSelectedFilterColumn] =
    useState<SearchableColumns>('id')
  useEffect(() => {
    if (debouncedSearchQuery) {
      onFilter(debouncedSearchQuery)
    }
  }, [debouncedSearchQuery])
  useEffect(() => {
    setDebouncedSearchQuery(searchQuery)
  }, [searchQuery])
  return (
    <Card>
      <Input
        id="olek-input-selector"
        addonBefore={
          <Select
            onSelect={(selectedColumn: SearchableColumns) => {
              setSelectedFilterColumn(selectedColumn)
            }}
            defaultValue={selectedFilterColumn}
            style={{ width: 150 }}
          >
            {searchableColumns.map(colName => (
              <Select.Option key={colName} value={colName}>
                {colName}
              </Select.Option>
            ))}
          </Select>
        }
        addonAfter={
          <>
            <Button
              onClick={() => {
                setSearchQuery({})
              }}
              size="small"
            >
              {`Filter ${t('labels.reset')}`}
            </Button>
            <Button
              style={{ visibility: 'hidden', width: 0 }}
              id="olek-button-selector"
              onClick={() => {
                try {
                  const inputValue = (
                    document.getElementById(
                      'olek-input-selector'
                    ) as HTMLInputElement
                  ).value
                  setDebouncedSearchQuery({
                    ...searchQuery,
                    [selectedFilterColumn]: inputValue,
                  })
                } catch (error) {
                  // biome-ignore lint/suspicious/noConsole: legacy code
                  console.error("Olek's selector is broken", error)
                }
              }}
              size="small"
            >
              {'Olek button'}
            </Button>
          </>
        }
        placeholder={t('labels.searchFor', { item: selectedFilterColumn })}
        value={searchQuery[selectedFilterColumn]}
        onChange={e =>
          setSearchQuery({
            ...searchQuery,
            [selectedFilterColumn]: e.target.value,
          })
        }
      />
    </Card>
  )
}

export default SourcesFilter
